import React from 'react';
import {
    InsertDriveFile as InsertDriveFileIcon,
    Delete as DeleteIcon,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import { formatFileSize } from 'ff/debrief/utils';

interface Props {
    file: File;
    onRemove: () => void;
}

const FilePreview = (props: React.PropsWithChildren<Props>) => {
    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                Selected File
            </Typography>
            <StyledFilePreview elevation={1}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <InsertDriveFileIcon
                        sx={{ fontSize: 40, color: 'primary.main' }}
                    />
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="body1" fontWeight="medium">
                            {props.file.name}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                            <Chip
                                label={formatFileSize(props.file.size)}
                                size="small"
                                variant="outlined"
                            />
                            <Chip
                                label={props.file.type}
                                size="small"
                                variant="outlined"
                            />
                        </Box>
                    </Box>
                    <Button
                        size="small"
                        onClick={props.onRemove}
                        startIcon={<DeleteIcon />}
                        color="error"
                        variant="outlined"
                    >
                        Remove
                    </Button>
                </Box>
            </StyledFilePreview>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                Review the file details above and click &#34;Import File&#34; to
                process it.
            </Typography>
        </Box>
    );
};

const StyledFilePreview = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.grey[50],
}));

export default FilePreview;
